import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    color: '#333333',
    backgroundColor: '#ffffff',
  },
  header: {
    marginBottom: 20,
    borderBottom: 1,
    borderBottomColor: '#3498db',
    paddingBottom: 10,
  },
  title: {
    fontSize: 18,
    marginBottom: 5,
    color: '#2c3e50',
    textAlign: 'center',
  },
  section: {
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 12,
    marginBottom: 8,
    color: '#2c3e50',
    backgroundColor: '#ecf0f1',
    padding: 5,
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ecf0f1',
    paddingVertical: 3,
    marginBottom: 3,
  },
  column: {
    flex: 1,
    paddingHorizontal: 5,
  },
  label: {
    fontSize: 9,
    color: '#7f8c8d',
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
  },
});

export default styles;
